import React from 'react';
import Divider from '@mui/material/Divider';
import HansenResultChecks from './HansenResultChecks';
import HansenResultMiddleValues from './HansenResultMiddleValues';
import HansenResultBcFactors from './HansenResultBcFactors';
import HansenResultInclinationFactors from './HansenResultInclinationFactors';
import HansenResultDepthFactors from './HansenResultDepthFactors';
import HansenResultShapeFactors from './HansenResultShapeFactors';
import HansenResultGroundFactors from './HansenResultGroundFactors';
import HansenResultBaseFactors from './HansenResultBaseFactors';
import HansenResultBearingCapacity from './HansenResultBearingCapacity';
import HansenResultEffectOfGroundWater from './HansenResultEffectOfGroundWater';

const HansenResult = ({ result }) => {
  const { isEccentricityX_OK, isEccentricityY_OK, isMinFndWidth_OK, isMinFndlength_OK, isSliding_OK } = result.output;
  const isAllChecksOK = isEccentricityX_OK && isEccentricityY_OK && isMinFndWidth_OK && isMinFndlength_OK && isSliding_OK;
  return (
    <section className="output hansenOutput">
      <h2>Output </h2>
      <HansenResultChecks result={result} isAllChecksOK={isAllChecksOK} />
      {isAllChecksOK && (
        <>
          <HansenResultMiddleValues result={result} />
          <HansenResultBcFactors result={result} />
          <HansenResultInclinationFactors result={result} />
          <HansenResultShapeFactors result={result} />
          <HansenResultDepthFactors result={result} />
          <HansenResultGroundFactors result={result} />
          <HansenResultBaseFactors result={result} />
          <HansenResultEffectOfGroundWater result={result} />
          <HansenResultBearingCapacity result={result} />
        </>
      )}
    </section>
  );
};

export default HansenResult;
